export function BrandMark({
  compact = false,
  inverse = false,
}: {
  compact?: boolean;
  inverse?: boolean;
}) {
  return (
    <span
      className={`brand-mark ${compact ? "brand-mark--compact" : ""} ${inverse ? "brand-mark--inverse" : ""}`}
      aria-label="VZ.live"
    >
      <span aria-hidden="true">VZ</span>
      <i aria-hidden="true" />
      {!compact && <span aria-hidden="true">live</span>}
    </span>
  );
}
